import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { SessionInvitations, PermissionLevelArrayValues } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  permissionLevel: z.enum(PermissionLevelArrayValues),
  expiresInHours: z.number().min(1).default(24),
  email: z.string().email().optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  inviteCode: string;
  inviteUrl: string;
  invitation: Selectable<SessionInvitations>;
};

export const createInvitation = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/invitations/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
